<template>
  <div class="container">
    <div
      class="subtitle is-4 pt-2 resultSearchTitle"
      v-if="numOfGyms !== 0"
    >
      Gyms near you
    </div>
    <div
      class="columns m1rema searchBar"
    >
      <div class="column searchBarCol is-6">
        <div class="columns has-text-centered field-box">
          <div class="column is-8">
            <InputSearch
              :resultSearch="true"
              @input="getSearchValue($event)"
              :search_value="search_value"
              @keyup.enter.native="search"
            />
          </div>
          <div
            class="column is-4"
          >
            <button
              class="button search-button slide-left h3rem w100"
              @click="search($event)" 
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div
          class="columns field-box has-text-centered is-mobile"
        >
          <div
            class="column is-4"
            v-for="(range, index) in ranges"
            :key="index"
          >
            <button
              :class="[
                'button',
                'is-rounded',
                'range-button',
                'results-range-button',
                'h3rem',
                isSelected(range)
                  ? 'active-range-button'
                  : 'not-active-range-button',
              ]"
              @click="selectRange($event, range)"
            >
              {{ range | formatRange }}
            </button>
          </div>
        </div>
      </div>
      <div
        class="column is-2 field-box"
      >
        <button
          class="button is-rounded range-button results-range-button has-icon-left h3rem filter-text"
          @click="openSidebar($event)"
        >
          <span title="Badge top right" class="badge">{{
            numOfSelectedFacilities
          }}</span>
          <span class="icon is-left mr-2"><i class="fas fa-filter"></i></span>
          {{ filterSidebar ? "Close Filters" : "Open Filters" }}
        </button>
      </div>
    </div>
    <div
      class="subtitle is-4 results-found-text"
      v-if="numOfGyms !== 0"
    >
      We've found
      <b>{{ numOfGyms }}</b>
      gym{{ numOfGyms === 1 ? "" : "s" }} within
      <b>{{ selected_range }}</b>
      mile{{ selected_range === 1 ? "" : "s" }} of {{ search_value }}
    </div>
  </div>
</template>

<script>
// import slugify from "slugify";
import InputSearch from "@/components/atoms/InputSearch.vue";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
//import GymCard from "@/components/molecules/GymCard.vue";
export default {
  data() {
    return {
      new_search_value: "",
      loading: false,
    };
  },
  components: {
    InputSearch,
    //GymCard
  },
  computed: {
    pre_selected_range() {
      return this.$store.state.selected_range;
    },
    ...mapGetters(["numOfSelectedFacilities"]),
    ...mapState([
      "search_value",
      "selected_range",
      "gyms",
      "facilities",
      "filterSidebar",
      "gymApiStatus",
      "numOfGyms"
    ]),
  },
  methods: {
    ...mapActions([
      "showSidebar",
      "findAllGyms",
      "findGyms",
      "resetFacilities",
    ]),
    ...mapMutations([
      "storeGyms",
      "storeRange",
      "storeSearch",
    ]),
    openSidebar(event) {
      event.target.blur();
      this.showSidebar();
    },
    clearFacilities(event) {
      event.target.blur();
      this.resetFacilities();
    },
    getSearchValue($event) {
      this.new_search_value = $event;
    },
    updateRange(val) {
      this.selected_range = val;
      this.selectRange(undefined, val);
    },
    async selectRange(event, range) {
      if (event) {
        event.target.blur();
      }
      this.storeRange(range);
      if (this.search_value) {
        await this.findGyms();
      } else {
        await this.findAllGyms();
      }
    },
    isSelected(range) {
      if (range == this.selected_range) {
        return true;
      } else {
        return false;
      }
    },
    loadingPromise() {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.buttonRender = false;
          this.loading = false;
          this.buttonRender = true;
          resolve();
        }, 1500);
      });
    },
    async search(event) {
      if (event) {
        event.target.blur();
      }
      let postCodeRegex = /^(([A-Za-z]{1,2}[0-9][A-Za-z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Za-z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Za-z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/;
      if (!postCodeRegex.test(this.new_search_value)) {
        alert("Please enter a valid Postcode");
        this.new_search_value = "";
        throw "Invalid postcode";
      }
      if (!this.new_search_value) {
        alert("Please enter a postcode");
        throw "Empty search";
      }
      this.buttonRender = false;
      this.loading = true;
      this.buttonRender = true;
      // await this.loadingPromise();
      this.$store.commit("storeSearch", this.new_search_value);
      if (this.search_value) {
        await this.findGyms();
      } else {
        await this.findAllGyms();
      }
    },
  },
  mounted() {
    this.new_search_value = this.$route.query.search.split("-").join("");
    this.storeRange(this.$route.params.range);
    this.$route.query.search
      ? this.storeSearch(this.$route.query.search)
      : this.storeSearch("");
  },
  props: {
    ranges: Array,
  },
};
</script>

<style scoped>

.field-box {
  background-color: white;
}

.h3rem {
  height: 3rem;
}

.resultSearchTitle {
  color: #2A2D36; 
  width: 100%;
  padding-left: 1rem; 
  margin: 1rem auto;
}

.results-found-text {
  color: #2A2D36; 
  width: 95%; 
  margin: 1rem;
}

.searchBar {
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  margin: 1rem auto;
}

@media only screen and (max-width: 950px){
  .filter-text {
    font-size: .8rem;
  }
}

@media only screen and (max-width: 768px){
  .searchBar{
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .filter-text{
    font-size: inherit
  }
  /* .searchBarCol{
    width: 100vw;
  } */
}

</style>
